/**
 * 流程action 后台API接口
 */
export var WorkflowApiActionStatus;
(function (WorkflowApiActionStatus) {
    WorkflowApiActionStatus[WorkflowApiActionStatus["APPROVAL"] = 0] = "APPROVAL";
    WorkflowApiActionStatus[WorkflowApiActionStatus["SUBMIT"] = 1] = "SUBMIT";
    WorkflowApiActionStatus[WorkflowApiActionStatus["CANCELLED"] = 2] = "CANCELLED";
    WorkflowApiActionStatus[WorkflowApiActionStatus["AGREE"] = 3] = "AGREE";
    WorkflowApiActionStatus[WorkflowApiActionStatus["DISAGREE"] = 4] = "DISAGREE";
    WorkflowApiActionStatus[WorkflowApiActionStatus["ADJUSTPARTICIPATORS"] = 5] = "ADJUSTPARTICIPATORS";
    WorkflowApiActionStatus[WorkflowApiActionStatus["ASSIST"] = 6] = "ASSIST";
    WorkflowApiActionStatus[WorkflowApiActionStatus["FORWARD"] = 7] = "FORWARD";
    WorkflowApiActionStatus[WorkflowApiActionStatus["REJECT"] = 8] = "REJECT";
    WorkflowApiActionStatus[WorkflowApiActionStatus["FINISHED"] = 9] = "FINISHED";
})(WorkflowApiActionStatus || (WorkflowApiActionStatus = {}));
/**
 * 流程action Web映射
 */
export var WorkflowWebActionStatus;
(function (WorkflowWebActionStatus) {
    WorkflowWebActionStatus["APPROVAL"] = "\u610F\u89C1";
    WorkflowWebActionStatus["SUBMIT"] = "\u63D0\u4EA4";
    WorkflowWebActionStatus["CANCELLED"] = "\u4F5C\u5E9F";
    WorkflowWebActionStatus["AGREE"] = "\u540C\u610F";
    WorkflowWebActionStatus["DISAGREE"] = "\u4E0D\u540C\u610F";
    WorkflowWebActionStatus["ADJUSTPARTICIPATORS"] = "\u52A0\u7B7E";
    WorkflowWebActionStatus["ASSIST"] = "\u534F\u529E";
    WorkflowWebActionStatus["FORWARD"] = "\u8F6C\u529E";
    WorkflowWebActionStatus["REJECT"] = "\u9A73\u56DE";
    WorkflowWebActionStatus["FINISHED"] = "\u7ED3\u675F\u6D41\u7A0B";
})(WorkflowWebActionStatus || (WorkflowWebActionStatus = {}));
/**
 * 参与者的类型
 */
export var WorkflowParticipantType;
(function (WorkflowParticipantType) {
    WorkflowParticipantType[WorkflowParticipantType["MORMAL"] = 0] = "MORMAL";
    WorkflowParticipantType[WorkflowParticipantType["FORWARD"] = 1] = "FORWARD";
    WorkflowParticipantType[WorkflowParticipantType["ASSIST"] = 2] = "ASSIST";
    WorkflowParticipantType[WorkflowParticipantType["ADD_WORKITEM"] = 3] = "ADD_WORKITEM";
    WorkflowParticipantType[WorkflowParticipantType["CIRCULATE_ITEM"] = 4] = "CIRCULATE_ITEM";
})(WorkflowParticipantType || (WorkflowParticipantType = {}));
export var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus[ActivityStatus["UNPASS"] = 0] = "UNPASS";
    ActivityStatus[ActivityStatus["PASS"] = 1] = "PASS";
    ActivityStatus[ActivityStatus["INPROGRESS"] = 2] = "INPROGRESS";
    ActivityStatus[ActivityStatus["NOTSTARTED"] = 3] = "NOTSTARTED"; // 未启动
})(ActivityStatus || (ActivityStatus = {}));
